import { ElLoading } from 'element-plus'; //ui组件

export default {
	LoadingShow:(Data) => {
		if(Data == '' || Data == null || Data == undefined){
			Data = 'Loading';
		}
		const Loading = ElLoading.service({
			lock: true,
			text: Data,
			background: 'rgba(255,255,255,0)',
		})
	},
	LoadingHide:(Data) => {
		if(Data == '' || Data == null || Data == undefined){
			Data = 'Loading';
		}
		const Loading = ElLoading.service({
			lock: true,
			text: Data,
			background: 'rgba(255,255,255,0)',
		})
		Loading.close();
	}
}

